<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">Not Exist</v-tab>
      <v-tab href="#tab-2">Exist</v-tab>
      <v-spacer></v-spacer>
      <add-remove-item
        :isAllTextFieldDisable="isAllTextFieldDisable"
        :isAcceptance="isAcceptance"
        :isDone="isDone"
      />
      <v-tab-item value="tab-1">
        <v-card flat>
          <repair-item-remove-not-in-resume
            :titleName="'acceptance_item_not_in_resume_title'"
            :repairItemsNotInResume="repairItemsNotInResume"
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isAcceptance="isAcceptance"
            :isDone="isDone"
            @setEditedRepairItemIndex="setEditedRepairItemIndex"
            @setEditedRemoveRepairItemNotInResume="setEditedNotExistRemoveRepairItem"
            @setDeleteItem="setDeleteNotExistRemoveRepairItem"
            @setItemIsNeedThrowResume="setRemoveRepairItemIsNeedThrowResume"
          />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <repair-item-remove-in-resume
            :titleName="'acceptance_item_in_resume_title'"
            :repairItemsInResume="repairItemsInResume"
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isAcceptance="isAcceptance"
            :isDone="isDone"
            @setEditedRepairItemIndex="setEditedRepairItemIndex"
            @setEditedRemoveRepairItemInResume="setEditedExistRemoveRepairItem"
            @setDeleteItem="setDeleteExistRemoveRepairItem"
          />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import RepairItemRemoveInResume from '@/components/Repair/RepairItemRemoveInResume.vue'
import RepairItemRemoveNotInResume from '@/components/Repair/RepairItemRemoveNotInResume.vue'
import AddRemoveItem from '@/components/Repair/AddRemoveItem.vue'
export default {
  components: { RepairItemRemoveInResume, RepairItemRemoveNotInResume, AddRemoveItem },
  name: 'RepairRemoveItem',
  props: {
    repairItemsInResume: {
      type: Array,
      default () {
        return []
      }
    },
    repairItemsNotInResume: {
      type: Array,
      default () {
        return []
      }
    },
    isDone: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editedRepairItemIndex: -1
  }),
  async mounted () {},
  computed: {},
  methods: {
    setDeleteNotExistRemoveRepairItem (val) {
      this.$emit('setDeleteNotExistRemoveRepairItem', val)
    },
    setDeleteExistRemoveRepairItem (val) {
      this.$emit('setDeleteExistRemoveRepairItem', val)
    },
    setEditedNotExistRemoveRepairItem (val) {
      this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
      this.$emit('setEditedRemoveRepairItemNotInResume', val)
    },
    setEditedRepairItemIndex (val) {
      this.editedRepairItemIndex = val
    },
    setEditedExistRemoveRepairItem (val) {
      this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
      this.$emit('setEditedRemoveRepairItemInResume', val)
    },
    setRemoveRepairItemIsNeedThrowResume (temp) {
      this.$emit('setRemoveRepairItemIsNeedThrowResume', temp)
    }
  }
}
</script>
